export const COLLECTION_PREFERENCES_ERRORS = Object.freeze({
  REQUESTED_DATE_NOT_AVAILABLE: 'requested_date_not_available',
  SELLER_PREFERENCE_ALREADY_SUBMITTED: 'seller_preference_already_submitted',
  SELLER_PREFERENCE_NOT_FOUND: 'seller_preference_not_found',
});

// if the message contains not available
// then we can run the callback and set the blocked dates to the first of the selections.
export const isDatesNotAvailableError = (err: Error): boolean => (err?.message?.includes('not available')
  || err?.message === COLLECTION_PREFERENCES_ERRORS.REQUESTED_DATE_NOT_AVAILABLE);

// if the message contains not found, an unlikely scenerio where a record as been deleted from the backend
// we can display a generic toast and get them to refresh the page where the state will reset
export const isSellerPreferenceNotFoundError = (err: Error): boolean => (err?.message?.includes('not found')
  || err?.message === COLLECTION_PREFERENCES_ERRORS.SELLER_PREFERENCE_NOT_FOUND);

// if the seller preferences have already been submitted
// then we can show a toast and refresh the state of the collection preferences to display the latest state.
export const isSellerPreferenceAlreadySubmitted = (err: Error): boolean =>
  err?.message === COLLECTION_PREFERENCES_ERRORS.SELLER_PREFERENCE_ALREADY_SUBMITTED;
